module.exports = __webpack_public_path__ + "res/26-img_timer.cabef3a095683bd3682a32c25e32fbe4.png";